import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ArticleCard } from "@/components/articles/ArticleCard";
import { ARTICLES } from "@/data/articles";
import "@/components/articles/articles.css";

export default function Articles() {
  const [params, setParams] = useSearchParams();
  const [query, setQuery] = useState(params.get("q") || "");
  useEffect(() => { setQuery(params.get("q") || ""); }, [params]);
  const updateQuery = (value) => {
    setQuery(value);
    setParams(value ? { q: value } : {}, { replace: true });
  };
  const terms = query.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
  const articles = ARTICLES.filter((article) => {
    const searchable = [article.title, article.category, article.excerpt, ...article.keywords].join(" ").toLocaleLowerCase();
    return article.status === "published" && terms.every((term) => searchable.includes(term));
  });

  return (
    <section className="insights-page container-x" data-testid="articles-page">
      <header className="insights-header">
        <span className="insights-label" data-testid="articles-label">Research & Insights</span>
        <h1 className="t-h1" data-testid="articles-heading">Discover our latest insights</h1>
        <p className="t-body" data-testid="articles-subtitle">Independent perspectives on financial markets, quantitative research<br className="hidden sm:block" /> and the ideas shaping the future of trading.</p>
        <form role="search" className="insights-search" onSubmit={(event) => { event.preventDefault(); updateQuery(String(new FormData(event.currentTarget).get("query") || "").trim()); }} data-testid="articles-search-form">
          <div className="insights-search-field">
            <Search size={16} aria-hidden="true" />
            <Input name="query" aria-label="Search articles" placeholder="Search articles, topics or keywords" value={query} onChange={(event) => updateQuery(event.target.value)} data-testid="articles-search-input" />
            {query && <button type="button" onClick={() => updateQuery("")} aria-label="Clear search" data-testid="articles-clear-search"><X size={15} /></button>}
          </div>
          <button type="submit" className="btn-primary" data-testid="articles-search-button">Search</button>
        </form>
      </header>
      <p className="sr-only" role="status" aria-live="polite" data-testid="articles-result-count">{articles.length} {articles.length === 1 ? "article" : "articles"} found</p>
      {articles.length ? (
        <div className="insights-grid" data-testid="articles-grid">
          {articles.map((article, index) => <ArticleCard key={article.slug} article={article} index={index} />)}
        </div>
      ) : (
        <div className="insights-empty" data-testid="articles-empty-state">
          <h2 className="t-h5">No matching insights</h2>
          <p className="t-body">Try another topic or keyword.</p>
          <button type="button" className="link-arrow" onClick={() => updateQuery("")} data-testid="articles-reset-search">View all articles</button>
        </div>
      )}
    </section>
  );
}